import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { CustomerProvider, useCustomerData } from '../customer/customerData';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material';
import { useStyles } from 'src/theme/vemigoCustomStyles/VemigoCustomStyles';
import { CustomerCarService } from 'src/services/customer/customerCarService';
import { DatePicker } from '@mui/lab';
import { StatusSwitch } from 'src/components/VemigoGrid/VemigoStarusFeild';
import { useCustomerBookingCart } from '../customer/selectedCustomerData';
import { BasicInfoService } from 'src/services/customer/baiscInfoService';

function AddCustomer(props) {
  const { open, handleClose, handleSaveData, label, onAddNewData, initialRows, data } = props;

  const dataModel = {
    id: 0,
    firstAndMiddleName: '',
    lastName: '',
    city: 0,
    area: 0,
    mobileNumber: '',
    emailId: '',
    birthday: '',
    anniversary: '',
    contactNumber1: '',
    contactNumber2: '',
    isActive: true
  };

  const { selectedCustomerData, handleGetCustomerCarById, setSelectedCustomer } =
    useCustomerBookingCart();

  const { allCities, allAreas } = useCustomerData();
  const [newData, setNewData] = useState(dataModel);
  const [selectedCarId, setSelectedCarId] = useState('');
  const { enqueueSnackbar } = useSnackbar();
  const [selectedCityList, setSelectedCityList] = React.useState([]);
  const [selectedCityId, setSelectedCityId] = React.useState('');
  const [selectedAreaList, setSelectedAreaList] = React.useState([]);
  const [selectedAreaId, setSelectedAreaId] = React.useState('');
  const [isAddButtonDisabled, setIsAddButtonDisabled] = useState(true);

  const handleAddClose = () => {
    setNewData(dataModel);
    handleClose();
  };

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        setSelectedAreaList(allAreas);
        setSelectedCityList(allCities);
      } catch (error) {
        console.error('Error fetching data from the API:', error);
      }
    };
    fetchData();
  }, [open]);

  const handleDataChange = (fieldName, value) => {
    setNewData({ ...newData, [fieldName]: value });
    if (
      newData.firstAndMiddleName &&
      newData.lastName &&
      newData.mobileNumber &&
      newData.city &&
      newData.area
    ) {
      setIsAddButtonDisabled(false);
    }
  };

  const handleAddNewData = () => {
    if (
      !newData.firstAndMiddleName ||
      !newData.lastName ||
      !newData.city ||
      !newData.area
    ) {
      enqueueSnackbar('Please fill in all mandatory fields', {
        variant: 'error'
      });
      return;
    }

    BasicInfoService.addData(newData)
      .then((data) => {
        setSelectedCustomer(data);
        handleSaveData(true);
      })
      .catch((error) => {
        console.error('Error updating data:', error);
      });

    handleAddClose();
  };

  const getFieldValue = (fieldId) => {
    if (fieldId.includes('.')) {
      const [parent, child] = fieldId.split('.');
      return newData[parent][child] || '';
    }

    return newData[fieldId] || '';
  };

  const allFields = [
    {
      id: 'firstAndMiddleName',
      field: 'textField',
      title: 'First And Middle Name',
      type: 'text',
      size: 12,
      palceHolder: 'First And Middle Name'
    },
    {
      id: 'lastName',
      field: 'textField',
      title: 'Last Name',
      type: 'text',
      size: 12,
      palceHolder: 'Last Name'
    },
    {
      id: 'city',
      field: 'Select',
      title: 'City Name',
      type: 'Select City',
      selectedId: selectedCityId,
      dataList: selectedCityList,
      function: setSelectedCityId,
      size: 6,
      palceHolder: 'City Name'
    },
    {
      id: 'area',
      field: 'Select',
      title: 'Area Name',
      type: 'Select Area',
      selectedId: selectedAreaId,
      dataList: selectedAreaList,
      function: setSelectedAreaId,
      size: 6,
      palceHolder: 'Area Name'
    },
    {
      id: 'mobileNumber',
      field: 'textField',
      title: 'Mobile Number',
      type: 'text',
      size: 6,
      palceHolder: 'Mobile Number'
    },
    {
      id: 'emailId',
      field: 'textField',
      title: 'Email Id',
      type: 'text',
      size: 6,
      palceHolder: 'Email Id'
    },
    {
      id: 'birthday',
      field: 'Date',
      title: 'Birthday',
      type: 'dateTime',
      size: 6,
      palceHolder: 'Birthday'
    },
    {
      id: 'anniversary',
      field: 'Date',
      title: 'Anniversary',
      type: 'dateTime',
      size: 6,
      palceHolder: 'Anniversary'
    },
    {
      id: 'contactNumber1',
      field: 'textField',
      title: 'ContactNumber 1',
      type: 'text',
      size: 6,
      palceHolder: 'ContactNumber 1'
    },
    {
      id: 'contactNumber2',
      field: 'textField',
      title: 'ContactNumber 2',
      type: 'text',
      size: 6,
      palceHolder: 'ContactNumber 2'
    }
  ];

  return (
    <>
      <Dialog open={open} onClose={handleAddClose} maxWidth="sm" fullWidth>
        <DialogTitle style={useStyles.dialogTitle}>{label}</DialogTitle>
        <DialogContent style={useStyles.bodyStyle}>
          <Grid container spacing={2}>
            {allFields.map((field) => (
              <Grid item xs={field.size} key={field.id}>
                <Typography style={useStyles.formTitle}>
                  {field.title}
                </Typography>
                {field.field === 'textField' && (
                  <TextField
                    style={useStyles.formControl}
                    margin="dense"
                    id={field.id}
                    type="dateTime"
                    fullWidth
                    value={getFieldValue(field.id) || ''}
                    onChange={(e) => handleDataChange(field.id, e.target.value)}
                    key={`textfield-${field.id}`}
                  />
                )}
                {field.field === 'Select' && (
                  <Select
                    style={useStyles.formControl}
                    fullWidth
                    value={field.selectedId}
                    onChange={(e) => {
                      handleDataChange(field.id, e.target.value);
                      field.function(e.target.value);
                    }}
                  >
                    <MenuItem value="" disabled key={`${field.id}-empty`}>
                      <em>{field.type}</em>
                    </MenuItem>
                    {field.dataList.map((data) => (
                      <MenuItem key={data.id} value={data.id}>
                        {field.id === 'carId'
                          ? `${data.name}-${data.brand.name}`
                          : data.name}
                      </MenuItem>
                    ))}
                  </Select>
                )}
                {field.field === 'Date' && (
                  <Grid item xs={12}>
                    <TextField
                      type="date"
                      fullWidth
                      variant="outlined"
                      value={getFieldValue(field.id) || ''}
                      onChange={(e) =>
                        handleDataChange(field.id, e.target.value)
                      }
                      inputProps={{}}
                    />
                  </Grid>
                )}
                {field.field === 'status' && (
                  <StatusSwitch
                    newData={newData}
                    handleSwitchChange={handleDataChange}
                    field={field.id}
                  />
                )}
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="contained">
            Cancel
          </Button>
          <Button
            onClick={handleAddNewData}
            color="primary"
            variant="contained"
          >
            {props.addBtn}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default AddCustomer;
